<template>
  <v-row align="end" justify="start">
    <v-col class="d-flex align-start justify-start">
      <div>
        <h3 class="white-content mb-2">{{ $t('rulesTitle') }}</h3>
        <p class="gray-content mb-1" v-bind:key="i" v-for="(ruleStatus, i) in $store.state.fundingTest.ruleStatuses">
          {{ $t(`rules.items.${ruleStatus.rule}`, { reference: Math.abs(ruleStatus.referenceValue) }) }}
        </p>
      </div>
      <div v-if="!collapsed" class="ml-3 flex-grow-1">
        <h3 class="white-content mb-2">{{ $t('performanceTitle') }}</h3>
        <div class="d-flex align-center justify-start mb-1" v-bind:key="i" v-for="(ruleStatus, i) in $store.state.fundingTest.ruleStatuses">
          <v-icon v-if="isWarningRule(ruleStatus)" color="accent" class="mr-n4" small>fa-exclamation-circle</v-icon>
          <v-icon v-else-if="isCompletedRule(ruleStatus)" color="#00F784" class="mr-n4" small>fa-check-circle</v-icon>
          <v-progress-linear v-if="isProgressRule(ruleStatus.rule)" class="ml-6"
                             :height="(isCompletedRule(ruleStatus) ||  isWarningRule(ruleStatus))? 8 : 7" rounded
                             :color="getProgressColor(ruleStatus)" :value="getRulePerformancePercentage(ruleStatus)"/>
          <p :class="(isProgressRule(ruleStatus.rule))? 'gray-content ml-2 my-0' : 'gray-content my-0 ml-6'" style="white-space: nowrap">{{ getRulePerformanceText(ruleStatus) }}</p>
          <!--v-chip v-if="ruleStatus.rule === 'CONSISTENCY'" class="ml-2" x-small><p style="font-size: 13px" class="my-0">{{ $t('seeDetailsBtn') }}</p></v-chip!-->
        </div>
      </div>
      <div v-else class="ml-3 flex-grow-1">
        <h3 class="white-content mb-2">{{ $t('performanceTitle') }}</h3>
        <div class="d-flex align-center justify-start mb-1" v-bind:key="i" v-for="(ruleStatus, i) in $store.state.fundingTest.ruleStatuses">
          <v-icon :color="wasBreakRule(ruleStatus.status)? '#FF6500' : '#00F784'" small>{{ wasBreakRule(ruleStatus.status)? 'fa-times-circle' : 'fa-check-circle' }}</v-icon>
          <p class="ml-2 my-0" style="white-space: nowrap">{{ lastRuleStatus(ruleStatus.status) }}</p>
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "RulesOverview",
  props: {
    collapsed: Boolean,
  },
  data() {
    return {
    };
  },
  methods: {
    wasBreakRule(status) {
      return status === 'VIOLATED' || status === 'NOT_REACHED';
    },
    lastRuleStatus(status) {
      return (status === 'VIOLATED')? this.$t('status.violated') : (status === 'NOT_REACHED')? this.$t('status.notReached') : this.$t('status.completed');
    },
    isProgressRule(rule) {
      let progressRules = ['MIN_TRADABLE_DAYS', 'MAX_MAE', 'MAX_DAILY_LOSS', 'MAX_WEEKLY_LOSS', 'MAX_DRAWDOWN', 'MAX_TRADE_SIZE'];
      return progressRules.findIndex((progressRule) => progressRule === rule) !== -1;
    },
    getRulePerformancePercentage(ruleStatus) {
      return Math.abs(ruleStatus.currentValue * 100) / Math.abs(ruleStatus.referenceValue);
    },
    isWarningRule(ruleStatus) {
      if(ruleStatus.rule === 'CONSISTENCY' && ruleStatus.status === 'NOT_REACHED')
        return true;

      let percentage =  this.getRulePerformancePercentage(ruleStatus);
      if(String(ruleStatus.rule).startsWith('MAX'))
        return (percentage > 90 && percentage < 100);

      return false;
    },
    isCompletedRule(ruleStatus) {
      return ((ruleStatus.rule === 'MAX_STOP_LOSS_PERCENTAGE') || (!String(ruleStatus.rule).startsWith('MAX') && (ruleStatus.status === 'REACHED' || ruleStatus.status === 'NOT_VIOLATED')));
    },
    getRulePerformanceText(ruleStatus) {
      let rule = ruleStatus.rule;
      if(this.isProgressRule(rule))
        return this.$t(`rules.summary.${ruleStatus.rule}`, { reference: Math.abs(ruleStatus.referenceValue), value: Math.abs(ruleStatus.currentValue) });

      if(rule === 'OVERNIGHT')
        return (ruleStatus.status === 'VIOLATED')? this.$t('rules.break') : this.$t('rules.complying');

      else if (rule === 'CONSISTENCY')
        return (ruleStatus.status === 'NOT_REACHED')? this.$t('rules.notComplying') : this.$t('rules.complying');

      return (ruleStatus.status === 'VIOLATED')? this.$t('rules.break') : this.$t('rules.complying');
    },
    getStatusIcons(ruleStatus) {
      switch (ruleStatus.status) {
        case 'VIOLATED':
          return 'fa-times-circle';
        case 'NOT_VIOLATED':
          return 'fa-check-circle';
        case 'REACHED':
          return 'fa-check-circle';
        case 'NOT_REACHED':
          return 'fa-minus-circle';
      }
    },
    getProgressColor(ruleStatus) {
      return String(ruleStatus.rule).startsWith('MAX')? '#FF6500': '#00F784';
    },
    getStatusColor(ruleStatus) {
      return (ruleStatus.status === 'VIOLATED')? '#FF6500': '#00F784';
      /*
      switch (ruleStatus.status) {
        case 'VIOLATED':
          return '#FF6500';
        case 'NOT_VIOLATED':
          return '#00F784';
        case 'REACHED':
          return '#00F784';
        case 'NOT_REACHED':
          return '#FFF75F';
      }*/
    },
    getParticipantStatusIcons(status) {
      switch (status) {
        case 'ACTIVE':
          return 'fa-check-circle';
        case 'WINNER':
          return 'fa-glass-cheers';
        case 'PAUSED':
          return 'fa-hourglass-half';
        case 'DISQUALIFIED':
          return 'fa-exclamation-circle';
      }
    },
    getParticipantStatusColor(status) {
      switch (status) {
        case 'ACTIVE':
          return '#00F784';
        case 'WINNER':
          return '#00F784';
        case 'PAUSED':
          return '#FFF75F';
        case 'DISQUALIFIED':
          return '#FF6500';
      }
    },
  },
}
</script>

<i18n>
{
  "en": {
    "rulesTitle": "Evaluation Rules",
    "performanceTitle": "Performance",
    "rules": {
      "items": {
        "MIN_TRADABLE_DAYS": "Minimum days of trading: {reference}",
        "MAX_MAE": "Maximum accepted loss in a trade: ${reference}",
        "MAX_DAILY_LOSS": "Maximum daily loss: ${reference}",
        "MAX_WEEKLY_LOSS": "Maximum weekly loss: ${reference}",
        "MAX_DRAWDOWN": "Maximum total loss: ${reference}",
        "MAX_TRADE_SIZE": "Maximum lots/contracts to trade: {reference}",
        "MAX_STOP_LOSS_PERCENTAGE": "Maximum Stop (Percentage): {reference}",
        "OVERNIGHT": "You can't trade overnigh.",
        "WITHOUT_NEWS": "You can't trade with news",
        "CONSISTENCY": "Your trading activity should be consistent"
      },
      "summary": {
        "MIN_TRADABLE_DAYS": "{value} of {reference}",
        "MAX_MAE": "-${value} of -${reference}",
        "MAX_DAILY_LOSS": "-${value} of -${reference}",
        "MAX_WEEKLY_LOSS": "-${value} of -${reference}",
        "MAX_DRAWDOWN": "-${value} of -${reference}",
        "MAX_TRADE_SIZE": "{value} of {reference}",
        "MAX_STOP_LOSS_PERCENTAGE": "{value}% of {reference}%"
      },
      "range": "{value} of {reference}",
      "break": "Break It",
      "notComplying": "Not Complying",
      "complying": "Complying"
    },
    "status": {
      "violated": "Broken",
      "notReached": "Not reached",
      "completed": "Completed"
    },
    "seeDetailsBtn": "See Details",
    "participantStatus": {
      "ACTIVE": "ACTIVE",
      "PAUSED": "YOU ARE NOT CONSISTENT",
      "WINNER": "YOU WIN THE EVALUATION!",
      "DISQUALIFIED": "DISQUALIFIED"
    }
  },
  "es": {
    "rulesTitle": "Reglas de la Prueba",
    "performanceTitle": "Rendimiento",
    "rules": {
      "items": {
        "MIN_TRADABLE_DAYS": "Mínimos días de operativa: {reference}",
        "MAX_MAE": "Máxima pérdida permitida en un trade: -${reference}",
        "MAX_DAILY_LOSS": "Máxima pérdida diaria: -${reference}",
        "MAX_WEEKLY_LOSS": "Máxima pérdida semanal: -${reference}",
        "MAX_DRAWDOWN": "Máxima pérdida total es: -${reference}",
        "MAX_TRADE_SIZE": "Máximos lotes/contratos a transar: {reference}",
        "MAX_STOP_LOSS_PERCENTAGE": "Máximo Stop Aceptado (Porcentual): {reference}",
        "OVERNIGHT": "No se puede operar en overnight",
        "WITHOUT_NEWS": "No se puede operar con noticias",
        "CONSISTENCY": "Tú operativa debe ser consistente"
      },
      "summary": {
        "MIN_TRADABLE_DAYS": "{value} de {reference}",
        "MAX_MAE": "-${value} de -${reference}",
        "MAX_DAILY_LOSS": "-${value} de -${reference}",
        "MAX_WEEKLY_LOSS": "-${value} de -${reference}",
        "MAX_DRAWDOWN": "-${value} de -${reference}",
        "MAX_TRADE_SIZE": "{value} de {reference}",
        "MAX_STOP_LOSS_PERCENTAGE": "{value}% de {reference}%"
      },
      "range": "{value} de {reference}",
      "break": "Incumplida",
      "notComplying": "Incumpliendo",
      "complying": "Cumpliendo"
    },
    "status": {
      "violated": "Incumplida",
      "notReached": "No alcanzada",
      "completed": "Completada"
    },
    "seeDetailsBtn": "Ver Detalles",
    "participantStatus": {
      "ACTIVE": "PARTICIPANDO",
      "PAUSED": "NO ERES CONSISTENTE",
      "WINNER": "¡GANASTE LA PRUEBA!",
      "DISQUALIFIED": "DESCALIFICADO"
    }
  }
}
</i18n>

<style lang="scss" scoped>
@import "src/global";

.primary-color {
  color: $primary-color;
}

.white-content {
  color: $white-color;
}

.gray-content {
  color: #BDBDBD;
}
</style>
